// overlayEvents — einzige Quelle der Overlay-Bus-Event-Namen (Außen-Naht Legacy↔Module).
// Schema: domain:subject:action. Siehe Plan legacy_overlay-js-modularization (Event-Vertrag).
//
// Nur diese Nähte laufen über den Mediator; der innere Datenfluss (Controller→State→View) bleibt
// Direktaufruf. Aktuell genutzt: UPLOAD_COMPLETE (Schnitt 1). Die übrigen sind der festgeschriebene
// Vertrag für die folgenden Schnitte (Gateway/Dirty/State).

export const OVERLAY_EVENTS = Object.freeze({
    PERSIST_REQUEST:   'overlay:persist:request',
    PERSISTED:         'overlay:persisted',
    DELETE_REQUEST:    'overlay:delete:request',
    DELETED:           'overlay:deleted',
    UPLOAD_COMPLETE:   'overlay:upload:complete',
    REKEYED:           'overlay:rekeyed',
    SELECTION_CHANGED: 'overlay:selection:changed',
});
